import { render } from "./ModalDynamicWrapper.vue?vue&type=template&id=b0c667c4"
import script from "./ModalDynamicWrapper.vue?vue&type=script&lang=js"
export * from "./ModalDynamicWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__